import { CustomElement, resolve } from 'aurelia';
import {
  AccountService,
  CalendarService,
  SavedSearchService,
  SubscriptionService
} from '../../services';
import template from './filter-panel.html';

// The left filter drawer: the search box, the save/load saved-search controls, and the
// source/brand checklists. Binds the filter state and toggles on CalendarService, the saved
// searches on SavedSearchService, the per-search notification bells on SubscriptionService, and
// reads AccountService for the signed-in gating of bells and the saved-search limit hint.
export class FilterPanelElement {
  readonly calendar: CalendarService = resolve(CalendarService);
  readonly savedSearch: SavedSearchService = resolve(SavedSearchService);
  readonly subscriptions: SubscriptionService = resolve(SubscriptionService);
  readonly account: AccountService = resolve(AccountService);
}

export const FilterPanel = CustomElement.define({
  name: 'filter-panel',
  template,
  // Render the <aside> in place (no host wrapper) so it stays a direct grid child of .main-layout.
  containerless: true
}, FilterPanelElement);
